import apiSlice from "./ApiSlice";
import { DispositionLevelOneFormValues } from "src/models/DispositionLevelOne.model";

export const dispositionLevelOneApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //

    // GET ALL
    getAllDispositionLevelOne: builder.query({
      providesTags: ["dispositionFirst"],
      query: (body) => {
        return {
          url: "/disposition-first",
          method: "GET",
          body,
        };
      },
    }),

    // GET
    getDispositionLevelOne: builder.query({
      providesTags: ["dispositionFirst"],
      query: (body) => {
        return {
          url: "/disposition-first",
          method: "POST",
          body,
        };
      },
    }),

    // GET SINGLE LANGUUAGE
    getDispositionLevelOneById: builder.query({
      providesTags: ["dispositionFirst"],
      query: (id) => {
        return {
          url: `/disposition-first/${id}`,
          method: "GET",
        };
      },
    }),

    // ADD
    addDispositionLevelOne: builder.mutation({
      invalidatesTags: ["dispositionFirst"],
      query: (body: DispositionLevelOneFormValues) => {
        return {
          url: "/disposition-first/add",
          method: "POST",
          body,
        };
      },
    }),

    // Edit
    editDispositionLevelOne: builder.mutation({
      invalidatesTags: ["dispositionFirst"],
      query: ({ id, body }) => {
        return {
          url: `/disposition-first/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // DELETE
    deleteDispositionLevelOne: builder.mutation({
      invalidatesTags: ["dispositionFirst"],
      query: (id) => {
        return {
          url: `/disposition-first/${id}`,
          method: "DELETE",
        };
      },
    }),

    //
  }),
});

export const {
  useGetAllDispositionLevelOneQuery,
  useGetDispositionLevelOneQuery,
  useGetDispositionLevelOneByIdQuery,
  useAddDispositionLevelOneMutation,
  useEditDispositionLevelOneMutation,
  useDeleteDispositionLevelOneMutation,
} = dispositionLevelOneApi;
